// extracted by mini-css-extract-plugin
export var alphabetListStyle = "Typography-module--alphabet--list-style--5a0d8";
export var blueColor = "Typography-module--blue--color--f9dcd";
export var boldWeight = "Typography-module--bold--weight--9abc7";
export var bulletListStyle = "Typography-module--bullet--list-style--7c110";
export var centerAlign = "Typography-module--center--align--36706";
export var copy = "Typography-module--copy--d400e";
export var heading = "Typography-module--heading--87443";
export var leadTheme = "Typography-module--lead--theme--8c059";
export var leftAlign = "Typography-module--left--align--16824";
export var lgFont = "Typography-module--lg--font--94e16";
export var lgLineHeight = "Typography-module--lg--line-height--3cac4";
export var lgSpacing = "Typography-module--lg--spacing--e4325";
export var lightWeight = "Typography-module--light--weight--15181";
export var mdFont = "Typography-module--md--font--9de8e";
export var mdLineHeight = "Typography-module--md--line-height--bc21f";
export var mdSpacing = "Typography-module--md--spacing--6160f";
export var noneListStyle = "Typography-module--none--list-style--26093";
export var noneSpacing = "Typography-module--none--spacing--af228";
export var normalWeight = "Typography-module--normal--weight--de685";
export var prose = "Typography-module--prose--063a4";
export var rightAlign = "Typography-module--right--align--d8d4f";
export var smFont = "Typography-module--sm--font--47ac1";
export var smLineHeight = "Typography-module--sm--line-height--bf19e";
export var smSpacing = "Typography-module--sm--spacing--79fb8";
export var xl2Font = "Typography-module--xl2--font--3d2c9";
export var xl2Spacing = "Typography-module--xl2--spacing--4267c";
export var xl3Font = "Typography-module--xl3--font--ed8ea";
export var xl3Spacing = "Typography-module--xl3--spacing--06dc2";
export var xlFont = "Typography-module--xl--font--ed5ab";
export var xlSpacing = "Typography-module--xl--spacing--e94ea";
export var xsFont = "Typography-module--xs--font--b890f";